import { AbstractControl, ValidationErrors } from "@angular/forms"

export const MatchValidator = (matchControl: AbstractControl) => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value !== matchControl.value) {
      return {
        match: true
      }
    }
    return null
  }
}
